import type { TimelineStep } from 'src/modules/automations/utils/executions/timeline/organize-timeline.util';
import type { BlockedValidatorDetails } from './types';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

/**
 * Reads a structured blocked Validator output from an organized timeline step.
 *
 * @param step - Timeline step to inspect.
 * @returns Display details for blocked Validator work, or null for any other step.
 */
export const getBlockedValidatorDetails = (
  step: TimelineStep
): BlockedValidatorDetails | null => {
  if (!('phase' in step.data) || step.data.phase !== 'validator') {
    return null;
  }

  const outputs = step.data.outputs;
  if (!isRecord(outputs)) {
    return null;
  }

  const action = outputs.action;
  if (action !== 'blocked-todo' && action !== 'blocked-objective') {
    return null;
  }

  const blocker = isRecord(outputs.blocker) ? outputs.blocker : undefined;
  const reason =
    typeof blocker?.reason === 'string' && blocker.reason.trim()
      ? blocker.reason.trim()
      : undefined;

  return {
    action,
    ...(typeof outputs.affectedTodo === 'string'
      ? { affectedTodo: outputs.affectedTodo }
      : {}),
    ...(reason ? { reason } : {}),
  };
};
